import { Component } from '@angular/core';
import {
  BackendUploadService,
  ItemView,
  ItemViewProviderDirective
} from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { tap } from 'rxjs';
import { ImagePanelComponent } from '../../image-panel/image-panel.component';

@Component({
  selector: 'app-remove-image',
  templateUrl: './remove-image.component.html'
})
export class RemoveImageComponent {
  constructor(
    protected backendUploadService: BackendUploadService,
    protected confirmationService: ConfirmationService,
    protected image: ImagePanelComponent,
    protected itemViewprovider: ItemViewProviderDirective<ItemView>
  ) {}

  removeImage() {
    this.confirmationService.confirm({
      message: 'Jeste li sigurni da želite obrisati sliku?',
      header: 'Brisanje slike',
      accept: () => {
        const viewState = this.itemViewprovider['_viewState'];
        const objectType = viewState.$itemType;
        const objectId = viewState.$parentId;
        const renditionName = 'default';

        if (viewState.$parent.$hasContent) {
          this.backendUploadService
            .removeContent(objectType, objectId, renditionName)
            .pipe(tap(() => this.itemViewprovider.reload()))
            .subscribe();
          viewState.$parent.$hasContent = false;
        }
        this.image.clearFiles();
      }
    });
  }
}
